export const appConfig = {
  pageSizes: [20, 50, 100, 500]
};
